<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12 lg12>
        <v-card flat style="border: 1px solid; border-color: #c2c2c2; border-radius: 5px; background-color: white;">
          <v-layout row wrap>
            <br>
            <span class="total" style="text-align: center; color: #666">LINK PARA INDICAÇÕES</span>
          </v-layout>
          <v-card-text style="font-size:18px; color: #828585;">
            <v-flex xs12 sm12 md12 lg12>
              <v-text-field
                :loading="carregaLink"
                style="margin-bottom: -25px"
                disabled
                outline
                v-model="linkIndicacao"
                single-line
              ></v-text-field>
            </v-flex>
            <v-container fill-height fluid pa-1 justify-center v-if="financialManagers.codeSaveS4Contract">
              <v-btn depressed color="orange" dark @click="doCopy(linkIndicacao)">COPIAR</v-btn>
              <v-btn depressed color="green">
                <a
                  style="color: white"
                  :href="`whatsapp://send?text=Clique no link abaixo para contratar seu plano PetHoo utilizando meu código de indicação!%0a%0a*Link*: ${linkIndicacao}`"
                >WHATSAPP </a>
              </v-btn>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <br>
    <v-divider />
    <br>
    <v-layout row wrap>
      <span class="total" style="text-align: center; color: #666">INDICAÇÕES REALIZADAS</span>
    </v-layout>
    <br>
    <v-data-table :headers="headersIndicacoes" :items="indicacoes" :loading="carregaTabelaIndicacao" class="elevation-3" rows-per-page-text="Exibições por página">
      <template v-slot:no-data>
        <v-alert :value="true" color="warning" icon="warning" style="border-radius: 5px">
          Nenhuma indicação realizada. Compartilhe seu link para obter indicações!
        </v-alert>
      </template>
      <template v-slot:items="props">
        <td class="text-xs-center" style="padding-top: 10px;">{{ props.item.indicadoNome }}</td>
        <td class="text-xs-center" style="padding-top: 10px;">R$ {{ props.item.bonus }}</td>
        <td class="text-xs-center" style="padding-top: 10px;">R$ {{ props.item.bonusDisponivel }}</td>
        <td class="text-xs-center" style="padding-top: 10px;">R$ {{ props.item.bonusUtilizado }}</td>
      </template>
    </v-data-table>
    <br>
    <v-divider />
    <br>
    <v-layout row wrap>
      <span class="total" style="text-align: center; color: #666">HISTÓRICO DE RESGATES</span>
    </v-layout>
    <br>
    <v-data-table :headers="headersHistorico" :items="historicos" class="elevation-3" rows-per-page-text="Exibições por página">
      <template v-slot:no-data>
        <v-alert :value="true" color="warning" icon="warning" style="border-radius: 5px">
          Nenhum histórico para exibir
        </v-alert>
      </template>
      <template v-slot:items="props">
        <td class="text-xs-center" style="padding-top: 10px;">R$ {{ props.item.valor }}</td>
        <td class="text-xs-center" style="padding-top: 10px;">{{ props.item.motivo }}</td>
        <td class="text-xs-center" style="padding-top: 10px;">{{ dataHoraPadrao(props.item.created) }}</td>
      </template>
    </v-data-table>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <v-btn dark flat @click="snackbar = false">Fechar</v-btn>
    </v-snackbar>
    <loading :active.sync="isLoading" :can-cancel="true" color="#7593b4" :is-full-page="fullPage"></loading> 
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
  import Snackbar from '../components/snackbar.vue'
  import axios from 'axios'
  import { baseApiUrl, modelBoleto } from '@/global'
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import moment from 'moment'
  export default {
    components: {Snackbar, Loading},
      data() {
        return {
          timeout: 4000,
          snackbar: false,
          textoSnackbar: '',
          exibeContrato: false,
          token: '',
          idBoleto: '',
          fullPage: true,  
          isLoading: false,
          status: '',
          protocoloCancelameto: '',
          dataContatacao: '',
          dialog: false,
          dialogCarteirinha:false,
          rowsPerPageItems: [1, 12, 18],
          pagination: {
            rowsPerPage: 10
          },
          email: '',
          activeBtn: 'Propostas',
          nomeUsuario: '',
          financialManager: [],
          financialManagers: {
            contratanteTitular: true,
            confirmPassword: '',
            password: '',
            rg: '',
            rgEmitter: '',
            homePhone: '',
            cellPhone: '',
            cellPhone2: '',
            email: '',
            cep: '',
            address: '',
            addressType: '',
            addressTypeName: '',
            addressNumber: '',
            addressComplement: '',
            district: '',
            city: '',
            state: '',
            proposalNumber: '',
            contractNumberS4: '',
            responsibility: '',
            cardNumber: '',
            cardValidity: '',
            cardFlag: '',
            cardDayExpiration: 15,
            dateSignatureContract: '',
            formOfPaymentId: '',
            formOfPayment: '',
            firstName: '',
            lastName: '',
            dateOfBirth: '',
            gender: null,
            maritalStatus: null,
            cpf: '',
            motherName: '',
            susNumber: '',
            plansId: '',
            nsu: '',
            TypeFm: 'FISICA',
            protocoloCancelamento: '',
            vendedor: '',
            matricula: '',
            stageForm: 1  
          },
          dependents: [],
          exibeCancelamento: false,
          propostaPendente: false,
          loading: false,
          loadingCancelamento: false,
          exibetextoCancelamento: true,
          cancelada: false,
          titleProposta: '',
          mensage1: '',
          mensage2: '',
          mensage3: '',
          pagamentoPendente: false,
          pagamentoAnalise: false,
          pagamentoAtivo: false,
          icon: '',
          iconTimer: '',
          proposalNumber: '',
          sales: [],
          loadingBoleto: false,
          cidade: '',
          estado: '',
          bairro: '',
          codEstado: '',
          boletosPendentes: [],
          exibeBoletosPendentes: false,
          headersIndicacoes: [
            { text: 'NOME', align: 'center', value: 'indicadoNome' },
            { text: 'BÔNUS', align: 'center', value: 'bonus' },
            { text: 'BÔNUS DISPONÍVEL', align: 'center', value: 'bonusDisponivel' },
            { text: 'BÔNUS UTILIZADO', align: 'center', value: 'bonusUtilizado' },
          ],
          headersHistorico: [
            { text: 'VALOR RESGATADO', align: 'center', value: 'valor' },
            { text: 'DESCRIÇÃO', align: 'center', value: 'motivo' },
            { text: 'DATA', align: 'center', value: 'created' },
          ],
          abreDialogoEmail: false,
          textoEmail: '',
          abreDialogoAtendimentos: false,
          anexos: {
            resultadoExames: '',
            protocolo: '',
            prontuario: '',
            recibo: '',
            conteudo: false,
          },
          visualizaAnexo: false,
          imagem: '',
          pdf: '',
          arquivoPdf: false,
          linkIndicacao: 'Carregando link...',
          indicacoes: [],
          historicos: [],
          carregaLink: true,
          carregaTabelaIndicacao: false,
          carregaTabelaHistorico: false,
        }
      },
    
      mounted : function(){
        //document.location.reload(true);
        if(localStorage.getItem('user') != null)
          this.nomeUsuario = localStorage.getItem('user')
        if(sessionStorage.getItem('email') != null)
          this.email = sessionStorage.getItem('email')
        if(localStorage.getItem('proposta') != null)
          this.financialManagers = JSON.parse(localStorage.getItem('proposta'))
        this.carregaProposta()
        this.pegaIndicacoes()
        this.pegaHistoricos()
      },

      methods: {
        async pegaIndicacoes() {
          this.carregaTabelaIndicacao = true
          this.isLoading = true
          await axios.post(`${baseApiUrl}Indicacoes/listaIndicados`, {"indicadorId": this.financialManagers.id})
          .then(response => {
            if (response.data) {
              this.indicacoes = response.data.indicados
              this.isLoading = false
              this.carregaTabelaIndicacao = false
            }
          }).catch(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao obter indicações","DESCULPE")
          })
        },

        async pegaHistoricos() {
          this.carregaTabelaHistorico = true
          await axios.get(`${baseApiUrl}HistoricoResgates?filter={"where":{"indicadorId":"${this.financialManagers.id}"},"order":"created DESC"}`)
          .then(response => {
            if (response.data) {
              this.historicos = response.data
              this.carregaTabelaHistorico = false
            }
          }).catch(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao obter histórico","DESCULPE")
          })
        },

        dataHoraPadrao(valor) {
          var dataHora = moment(valor).format("DD/MM/YYYY HH:mm:ss")
          return dataHora
        },

        async carregaProposta() {
          this.loading = true
          await axios.get(`${baseApiUrl}/FinancialManagers?filter={"where":{"id":"${this.financialManagers.id}"}}`).then(res => {        
            if(res.data != ''){   
              //this.financialManagers = res.data[0] 
              this.financialManager = res.data               
              if (this.financialManagers.codeSaveS4Contract) {
                this.linkIndicacao = "https://maispetoficial.intelite.com.br/pessoafisica?indicacao=" + this.financialManagers.codeSaveS4Contract
              } else {
                this.linkIndicacao = "Não foi possível obter seu link de indicação. Tente novamente"
              }
              this.carregaLink = false
            }
          })           
          /* await axios.get(`${baseApiUrl}Plans?filter[where][id]=${this.financialManager[0].plansId}`).then(res => {        
            if(res.data != null){      
              this.financialManager[0].planoSelecionado.push(res.data[0].value,res.data[0].area_atuacao,res.data[0].qualificacao,res.data[0].registro,res.data[0].name,res.data[0].cobertura,res.data[0].id,"",res.data[0].urlMinutaContrato,res.data[0].urlMinutaAditivo,res.data[0].urlManual,res.data[0].urlGuia,res.data[0].urlCobertura)   
              console.log(this.financialManager[0])
            }
          }) */
          await axios.get(`${baseApiUrl}/Sales?filter={"where":{"financialManagerId":"${this.financialManager[0].id}"}}`).then(res => {
            if(res.data != ''){
              this.sales = res.data[0]
              this.dataContatacao = this.formatDateBrz(res.data[0].salesmanConfirm.substr(0, 10))
              var dat = new Date(res.data[0].salesmanConfirm.substr(0, 10))
              dat.setDate(dat.getDate() + 7)
              if(dat.toISOString().substr(0, 10) >= new Date().toISOString().substr(0, 10))
                this.exibeCancelamento = true
              else
                this.exibeCancelamento = false   
              this.status = res.data[0].status 
              if (this.financialManager[0].TypeFm == 'FISICA') {
                this.mensage1 = '1 - Aguardando confirmação de pagamento'
                this.mensage2 = '2 - Pagamento confirmado'
                this.mensage3 = '3 - Proposta em análise'
                this.icon = 'check_circle'
                this.iconTimer = 'hourglass_empty'
              } else
                if (this.financialManager[0].TypeFm == 'SERVIDOR') {
                  this.mensage1 = '1 - Aguardando confirmação do orgão averbador'
                  this.mensage2 = '2 - Averbação confirmada'
                  this.mensage3 = '3 - Proposta em análise'
                  this.icon = 'check_circle'
                  this.iconTimer = 'hourglass_empty'
                }
                switch (this.status) {
                  case 'PAGAMENTO PENDENTE':
                    this.pagamentoPendente = false
                    this.pagamentoAnalise = false
                    this.pagamentoAtivo = false  
                    this.propostaPendente = false                 
                    this.exibeContrato = true
                    this.titleProposta = 'Andamento da Proposta' 
                    break
                  case 'EM AVERBAÇÃO':
                    this.pagamentoPendente = false
                    this.pagamentoAnalise = false
                    this.pagamentoAtivo = false  
                    this.propostaPendente = false                 
                    this.titleProposta = 'Andamento da Proposta' 
                    break
                  case 'EM VALIDAÇÃO':
                    this.pagamentoAnalise = true
                    this.pagamentoPendente = true
                    this.pagamentoAtivo = false
                    this.propostaPendente = false
                    this.titleProposta = 'Andamento da Proposta' 
                    break
                  case 'ATIVO':
                    this.pagamentoAtivo = true
                    this.titleProposta = 'Selecione uma opção abaixo' 
                    break
                }
            } else {
              this.propostaPendente = true
              this.titleProposta = 'Selecione uma opção abaixo'
            }
          }) 
          this.loading = false
        },

        doCopy(texto) {
          try {
            navigator.clipboard.writeText(texto)
            this.snackbar = true
            this.textoSnackbar = 'Link copiado para a área de transferência!'
          } catch (error) {
            this.snackbar = true
            this.textoSnackbar = 'Problema ao copiar link para a área de transferência'
          }
        },

        async concluirProposta() {
          //localStorage.clear()
          //sessionStorage.clear('FinancialManager')
          await axios.get(`${baseApiUrl}/Dependents?filter={"where":{"financialManagerId":"${this.financialManager[0].id}"}}`).then(res => {        
            if(res.data != ''){   
              this.dependents = res.data                      
            }
          })
          this.financialManager[0].cep = this.financialManager[0].cep.replace('.','')
          sessionStorage.setItem('FinancialManager',JSON.stringify(this.financialManager[0]))
           //localStorage.setItem('Dependentes',JSON.stringify(this.dependents))
           //console.log('Dependentes', this.dependents)
          switch (this.financialManagers.TypeFm) {
            case 'FISICA':
              this.$router.push({ path: '/contratopf' })
              break;
            case 'SERVIDOR':
              this.$router.push({ path: '/contratosp' })
              break;           
            default:
              break;
          }
        },

        openDialog() {
          this.dialog = true
          this.exibetextoCancelamento = true
        },
        
        close() {
          this.dialog = false
        },

        closeConfirmacao() {
          this.$store.dispatch('Sair')
          this.$router.push({ path: '/areacliente' })
        },

        async cancelarProposta() {
          this.geraProtocolo()
          this.exibetextoCancelamento = false
          this.cancelada = false
          this.loadingCancelamento = true         
          //this.dialog = false
          //salvar o id do cancelamento no sales e o protocolo no FM
          await axios.post(`${baseApiUrl}FinancialManagers/update?[where][id]=${this.financialManager[0].id}`, {"protocoloCancelamento" : this.protocoloCancelameto})
          await axios.patch(`${baseApiUrl}Sales/${this.sales.id}`, {"cancellationId" : "5d44ef0511d3041d7a33e767", "status": "CANCELADO"})          
          setTimeout(() => {
            this.loadingCancelamento = false
            this.cancelada = true
          }, 3000);          
        },

        formatDateBrz (date) {
          if (!date) return null
          const [year, month, day] = date.split('-')
          return `${day}/${month}/${year}`
        },

        geraProtocolo() {
          var data = new Date();
          this.protocoloCancelameto = '416525' + data.getFullYear() + ("0" + (data.getMonth() + 1)).substr(-2) + ("0" + data.getDate()).substr(-2)+Math.floor(10 + Math.random() * 99) + data.getHours() + ("0" +data.getMinutes()).substr(-2);
        },

        async baixar2ViaBoleto() {
          // verifica se o boleto está pago
          if (this.sales.status != 'ATIVO') {
            this.loadingBoleto = true
            var situacaoBoleto = ''
            try {
              let res = await axios.get(`${baseApiUrl}/FinancialManagers?filter={"where":{"id":"${this.financialManagers.id}"}}`)
                if (res.data != '') {
                  situacaoBoleto = res.data[0].situacaoBoleto
                  if (situacaoBoleto == "VENCIDO")
                    this.gerarBoleto()
                  else if (situacaoBoleto == "REGISTRADO" || situacaoBoleto == "GERADO") {
                    try {
                      let resp = await axios.get(`${baseApiUrl}/Sales?filter={"where":{"financialManagerId":"${this.financialManagers.id}"}}`)
                      if (resp.data != '') {
                        this.idBoleto = resp.data[0].boletoId
                        this.imprimirBoleto()                     
                      }
                    } catch (error) {
                      var vm = this;
                      vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao consultar venda!","ERRO");
                    }
                  } else if (situacaoBoleto == 'PAGO') {
                    this.loadingBoleto = false
                    vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Detectamos que o pagamento do boleto já foi efetuado!","ATENÇÃO")
                  } else if (situacaoBoleto == "BAIXADO") {
                    this.loadingBoleto = false
                    vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","O boleto para essa proposta encotra-se baixado, para mais informações entre em contato com a Orale.","ATENÇÃO")
                  }
                }
            } catch (error) {
              this.loadingBoleto = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao consultar status do boleto!","ERRO");
            }
          } else {
            this.loadingBoleto = true
            try {
              await axios.get(`${baseApiUrl}Pagamentos/pagadorDocumentoNumero?pagador=${this.financialManagers.cpf}`).then(res => {
                if (res.data) {
                  for (let i = 0; i < res.data.length; i++) {
                    if (res.data[i].situacao == 'VENCIDO' || res.data[i].situacao == 'REGISTRADO') {
                      this.boletosPendentes.push({
                        'nossoNumero': res.data[i].nossoNumero,
                        'situacao': 'A VENCER',
                        'vencimento': this.formatDateBrz(res.data[i].dataVencimento.substring(0, 10)),
                        'id': res.data[i].id
                      })
                    }
                  }
                  this.exibeBoletosPendentes = true
                }
              })
              this.loadingBoleto = false
            } catch (error) {
              this.loadingBoleto = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao consultar boletos!","DESCULPE");
            }
          }
        },

        //Método para baixar segunda via do boleto 
        async imprimirBoleto(item) {
          if (this.sales.status == 'ATIVO') {
            this.idBoleto = item.id
          }
          this.isLoading = true
          this.loadingBoleto = true
          //Baixando Boleto PDF
          await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.idBoleto}/imprimir`,{ responseType: 'arraybuffer', headers: {
            /* Authorization: 'Bearer ' + token, */ //the token is a variable which holds the token
            'Content-type': 'application/pdf'
          }
          })
          .then(response => {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [response.data], 
              {type: 'application/pdf'});
              //Build a URL from the file
              const fileURL = URL.createObjectURL(file);
              const link = document.createElement('a');
              link.href = fileURL;
              link.setAttribute('download', 'boleto.pdf'); //or any other extension
              document.body.appendChild(link);
              link.click();
              //Open the URL on new Window
              window.open(fileURL);        
              this.isLoading = false
          })
          .catch(() => {
            this.isLoading = false
            this.loadingBoleto = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao imprimir Boleto","ERRO");
            this.close()   
            return           
          })
          this.loadingBoleto = false
        },

        print() {
          var vm = this;
          vm.$refs.proposta.print();
        },

        async visualizaContrato() {
          await axios.get(`${baseApiUrl}Plans?filter[where][id]=${this.financialManager[0].plansId}`).then(res => {        
            if(res.data != null){      
              window.open(res.data[0].urlContrato)
            }
          })      
        },
    
        openCarteirinha() {
          this.dialogCarteirinha = true
        },

        printCarteirinha() {
          var vm = this;
          vm.$refs.carteirinha.print();
        },

        async pegaUfPagador() {
          await axios.get(`${baseApiUrl}UFs?filter={"where":{"codeS4":${this.codEstado}}}`).then(res => {        
            if (res.data != null) {
              this.estado = res.data[0].prefix   
            }
          })
        },

        async gerarBoleto() {        
          this.loadingBoleto = true
          //this.token = ''
          this.idBoleto = ''
          //Pegar Token
          /* try {
            let res = await axios.get(`${baseApiUrl}Pagamentos/token`)
              if(res.data != ''){
                this.token = res.data.token
              }
          } catch (error) {
            this.loadingBoleto = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao se conectar com a plataforma de pagamento, tente mais tarde!","ERRO");
            this.close()
          } */
          //Criando data de vencimeto do boleto
          var datapagvenc = new Date();
          var nossoNum = this.financialManagers.proposalNumber.toString() +Math.floor(10 + Math.random() * 99)
          datapagvenc.setDate(new Date().getDate() + 2)
          //Preencher o campos do model de Boleto
          modelBoleto.pagadorDocumentoNumero = this.financialManagers.cpf.replace(/[^\d]+/g,'')
          modelBoleto.pagadorNome = this.financialManagers.firstName.substr(0, 39)
          modelBoleto.pagadorEndereco = this.financialManagers.address.substr(0, 39) + ', ' + this.financialManagers.addressNumber
          modelBoleto.pagadorBairro = this.bairro.substr(0, 19)
          modelBoleto.pagadorCidade = this.cidade.substr(0, 19)
          modelBoleto.pagadorUf = this.estado
          modelBoleto.pagadorCep = this.financialManagers.cep.replace(/[^\d]+/g,'');
          modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
          modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
          modelBoleto.valorNominal = parseFloat(this.financialManagers.responsibility)
          modelBoleto.mensagem = 'Referente à segunda via de boleto - Proposta de Número: ' + this.financialManagers.proposalNumber
          modelBoleto.nsu = this.financialManagers.proposalNumber
          modelBoleto.nossoNumero = nossoNum.substr(0,12)
          modelBoleto.seuNumero = nossoNum.substr(0,12)
          //Gerando o Boleto e pegando o ID
          try {
            let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
            if(res.data != ''){
              this.idBoleto = res.data.id
              this.imprimirBoleto()
              this.atualizaFMeSales()
            }
          } catch (error) {
            this.loadingBoleto = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar Boleto, tente novamente!","ERRO");
            //this.close()                 
          }
        },
      
        async atualizaFMeSales() {
          try {
            await axios.post(`${baseApiUrl}FinancialManagers/update?[where][id]=${this.financialManagers.id}`, {"situacaoBoleto" : "GERADO", "nossoNumero" : modelBoleto.nossoNumero})
          } catch (error) {
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao atualizar situação do boleto no cliente, tente novamente","ATENÇÃO")                   
          }
          try {
            await axios.post(`${baseApiUrl}Sales/update?[where][id]=${this.sales.id}`, {"boletoId" : this.idBoleto})
          } catch (error) {
            var vm = this;
            /* vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao atualizar situação do boleto na venda, tente novamente","ATENÇÃO")  */                  
          }
        },

        async enviaEmail () {
          this.isLoading = true
          let envio = {
            "financialManagerId": this.financialManagers.id,
            "texto": this.textoEmail,
            "origem": "CLIENTE"
          }
          try {
            await axios.post(`${baseApiUrl}ContatoClientes/NovoContato`, envio)
            .then(response => {
              if (response.data) {
                this.isLoading = false
                var vm = this;
                vm.$refs.chamaSnackbar.snack("#8FF925","Agradecemos a sua mensagem. Em breve, entraremos em contato!","MENSAGEM ENVIADA")
              }
            }).catch(() => {
              this.isLoading = false
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao enviar mensagem, tente novamente!","DESCULPE");
            })
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao enviar mensagem, tente novamente.","DESCULPE!")
          }
        },

        async menuAtendimentos() {
          this.isLoading = true
          try {
            await axios.get(`${baseApiUrl}ImagesDocs?filter={"where":{"financialManagerId":"${this.financialManagers.id}"}}`).then(response => {
              if (response.data) {
                this.anexos = response.data[0]
                this.anexos.conteudo = true
                this.abreDialogoAtendimentos = true
                this.isLoading = false
              }
            })
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao buscar atendimentos, tente novamente.","DESCULPE!")
          }
        },

        visualizarAnexo(base64, tipo) {
          if (tipo == 'data:appli') {
            this.arquivoPdf = true
            this.pdf = base64
          } else if (tipo == 'data:image') {
            this.arquivoPdf = false
            this.imagem = base64
          }
          this.visualizaAnexo = true
        },
      }
  }
</script>

<style>
  .theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
    border-radius: 10px;
  }

  .informativo {
    font-size: 25px;
    color: #7e2985;
    line-height: 30px;
    margin-top: 5px;
    display: block;
    font-weight: bold;    
  }

  .mensageCheck {
    font-weight: 700;
    font-size: 18px;
    color: #c7c7c7;
  }

  .mensages {
    font-weight: 700;
    font-size: 18px;
    color: #797a7a;
  }

  .imagem {
    min-width: 80%;
  }

  a {
    text-decoration: none;
  }

  .v-table__overflow {
    border-radius: 0px;
  }

  table.v-table thead tr th {
    background-color: orange !important;
  }
</style>
